export default "__VITE_ASSET__24rfFCko__"